/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { Measurement } from '../../components/measurement';
import { VisionRockingTab } from './rocking';

/** Handles the Dashboard elements for the Rocking Tab
 *
 */
export class RockingDashboard {
    tab: VisionRockingTab;

    constructor(tab: VisionRockingTab) {
        this.tab = tab;

        this.tab.layout.cells('c').collapse();
        this.tab.layout.cells('c').setText('Dashboard');
        this.tab.layout.cells('c').attachHTMLString(`
    <div class="dashboard">
    <div class="widget">
      <div class="widget-header">Days Left</div>
      <div class="widget-body">
        <div class="dasboardtext" id="daysValue">--</div>
      </div>
    </div>

    <div class="widget">
      <div class="widget-header">Rock Total</div>
      <div class="widget-body">
        <div class="dasboardtext" id="rockTotal">--</div>
      </div>
    </div>

    <div class="widget">
      <div class="widget-header">Complete Trend</div>
      <div class="widget-body">
        <div class="dasboardtext" id="day_rate">--</div>
      </div>
    </div>

    </div>
`);
    }

    updateTrend(total: number, required: number, start: string, end: string) {
        const endDate = new Date(end);
        const startDate = new Date(start);
        const now = new Date();

        const diff = endDate.getTime() - now.getTime();
        const daysLeft = Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));

        const diff2 = now.getTime() - startDate.getTime();
        const daysDone = Math.max(0, Math.ceil(diff2 / (1000 * 60 * 60 * 24)));

        const dailyAverage = daysDone / total;
        const remainingRock = required - total;

        const trendingDays = dailyAverage * remainingRock;
        const element = document.getElementById('day_rate');
        if (element) {
            if (daysLeft) element.textContent = 'In: ' + Math.round(trendingDays).toString() + ' days';
        }
    }

    /** Set the total amount of rock so far.
     *
     * @param total
     */
    updateRockTotal(total: number, required: number) {
        const element = document.getElementById('rockTotal');
        const percent = Math.round((total / required) * 100);
        if (element) {
            element.textContent = Measurement.kg2ImperialTons(total).toString() + ' of ' + Measurement.kg2ImperialTons(required).toString() + ' (' + percent + '%)';
        }
    }

    updateCountdown(end: string) {
        const targetDate = new Date(end);
        targetDate.setDate(targetDate.getDate()); // adjust for your deadline

        const now = new Date();
        const diff = targetDate.getTime() - now.getTime();
        const daysLeft = Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));

        const elementDays = document.getElementById('daysValue');
        if (elementDays) {
            if (daysLeft) elementDays.textContent = daysLeft.toString();
        }

        const elementDate = document.getElementById('dueDateText');
        if (elementDate) {
            elementDate.textContent = 'Due by: ' + targetDate.toDateString();
        }
    }
}
